<template>
    <input type="radio"
        :value="val"
        :id="id"
        :disabled="disabled"
        v-model="checked"
        @change="onChange">
</template>
<script>
export default {
    props:{
        value: false,
        val: false,
        id: false,
        disabled:{
            default: false,
            type: Boolean
        },
    },
    data: function() {
        return {
            checkedProxy: false
        }
    },
    computed: {
        checked: {
            get () {
                return this.value
            },
            set (val) {
                this.checkedProxy = val
            }
        }
    },
    methods:{
        onChange: function(e) {
            this.$emit('input', this.checkedProxy);
        }
    }
}
</script>
